<template>
  <v-autocomplete
    v-model="model"
    :items="organizations"
    :loading="isLoading"
    item-text="name"
    item-value="id"
    label="Organization"
    @input="handleInput"
    :required="required"
    :rules="rules || []"
    clearable
  >
    <template slot="item" slot-scope="{ item: organization }">
      <v-list-tile-avatar>
        <img :src="organization.logo || '/img/missing/logos/organizations/original.png'" />
      </v-list-tile-avatar>

      <v-list-tile-content v-if="organization">
        <v-list-tile-title v-if="organization.name" v-html="organization.name" />
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>

<script>
// Helpers
import { mapState } from 'vuex'

// Vue Component
export default {
  props: {
    value: { required: true },
    required: { type: Boolean, default: () => false },
    rules: { type: Array, default: () => [] },
  },

  created() {
    this.$store.dispatch('admin/organizations/fetchAll')
  },

  data() {
    return {
      // Always store ID in the model
      model: this.normalizedValue(this.value),
    }
  },

  computed: {
    ...mapState('admin/organizations', ['all']),

    isLoading() {
      return this.loading
    },

    organizations() {
      if (this.all && this.all.length) return this.all
      return []
    },
  },

  watch: {
    value(newVal) {
      this.model = this.normalizedValue(newVal)
    },
  },

  methods: {
    normalizedValue(val) {
      if (val && typeof val === 'object') return val.id
      return val || null
    },
    handleInput(selected) {
      const id = this.normalizedValue(selected)
      this.$emit('input', id)
    },
  },
}
</script>
